<template>
    <div class="lms__user_achievements_edit_rewards">
        <form-select
            :label="$t('lms.user.reward.labels.chooseRewards')"
            :name="'lms-user-achievements-reward-choose-rewards'"
            @input="achievementSetRewards"
            :items="rewards"
            :value="achievementRewards"
            :searchable="false"
            :is-type="'select'"
        >{{ $t('lms.user.achievements.text.cantFindReward') }}
            <component-button
                :text="true"
                :size="'tiny'"
                :name="''"
                @click="performCreateReward"
            >{{ $t('lms.user.achievements.text.clickingHere') }}
            </component-button>
        </form-select>
        <form-submit
            :reset-button-text="$t('lms.user.achievements.buttons.resetChanges')"
            :submit-button-text="$t('lms.user.achievements.buttons.saveAchievement')"
            @reset="performReset"
            @submit="performSubmitValidate"
        />
        <pop-notify
            ref="popnotifycreatereward"
            :class="'pop__notify--createreward'"
            :title-text="$t('lms.user.achievements.notify.saveChanges')"
            :content-text="$t('lms.user.achievements.notify.leaveThePage')"
            :cancel-button-text="$t('lms.user.achievements.notify.cancelButton')"
            :custom-button-danger="true"
            :custom-button-active="true"
            :custom-button-text="$t('lms.user.achievements.notify.customButton')"
            :submit-button-text="$t('lms.user.achievements.notify.submitButton')"
            :prevent-close="true"
            :size="'medium'"
            @emit-submit="achievementSubmitRedirectToReward"
            @emit-custom="redirectToCreateReward"
        />
    </div>
</template>
<script>
import PopNotify from '@/components/default/shared/PopNotify'
import FormSelect from '@/components/default/forms/FormSelect'
import FormSubmit from '@/components/default/forms/FormSubmit'
import { validateBeforeRouteLeave, performReset, performSubmitValidate, performSubmitValidatePromise, watchContentChangeEmit } from '@/helpers/mixins'
import ComponentButton from '@/components/default/shared/ComponentButton'

export default {
  name: 'lms-user-achievements-edit-rewards',
  mixins: [validateBeforeRouteLeave, performReset, performSubmitValidate, performSubmitValidatePromise, watchContentChangeEmit],
  components: {
    ComponentButton,
    FormSelect,
    FormSubmit,
    PopNotify
  },
  computed: {
    achievementId () {
      return this.$store.getters.getLmsUserAchievementId
    },
    achievementRewards () {
      const rewards = this.$store.getters.getLmsUserAchievementRewards
      return rewards.map(reward => {
        return reward.rewardId
      })
    },
    watchContent () {
      return this.achievementRewards
    },
    rootItemName () {
      return 'achievement'
    },
    rootParent () {
      return this.$parent.$parent.$parent
    },
    nameActionCreate () {
      return 'lmsUserAchievementCreate'
    },
    nameActionUpdate () {
      return 'lmsUserAchievementUpdate'
    },
    nameActionReset () {
      return 'lmsUserAchievementReset'
    },
    rewards () {
      const roles = this.$store.getters.getLmsUserRewards
      if (!roles.length) return []
      return roles.map((object) => {
        return {
          label: object.name + object.id,
          customLabel: object.name,
          value: object.id
        }
      })
    }
  },
  methods: {
    openCreateRewardNotify () {
      this.$refs.popnotifycreatereward.openNotify()
    },
    achievementSubmitRedirectToReward () {
      this.performSubmitValidatePromise(false).then((response) => {
        const achievementId = response.data.id
        this.$router.push({
          name: 'lms-user-achievement-reward-add',
          query: {
            achievementId: achievementId
          }
        })
      }).catch(() => {
        this.$refs.popnotifycreatereward.closeNotify()
      })
    },
    redirectToCreateReward () {
      this.allowRedirectBeforeRouteLeave()
      this.$router.push({
        name: 'lms-user-achievement-reward-add',
        query: {
          achievementId: this.$route.params.id
        }
      })
    },
    achievementSetRewards (value) {
      this.$store.dispatch('lmsUserAchievementSetRewards', value)
    },
    getRewards () {
      this.$store.dispatch('lmsUserRewardsGet').then(response => {
        const routeQueryRewardId = this.$route.query.rewardId
        if (routeQueryRewardId) {
          this.achievementSetRewards({ value: routeQueryRewardId })
        }
      })
    },
    performCreateReward () {
      if (this.rootParent.continueRedirect) {
        const achievementId = this.achievementId
        this.$router.push({
          name: 'lms-user-achievement-reward-add',
          query: {
            achievementId: achievementId
          }
        })
      } else {
        this.openCreateRewardNotify()
      }
    }
  },
  created () {
    this.getRewards()
  },
  provide () {
    return {
      $validator: this.$validator
    }
  }
}
</script>
